// extracted by mini-css-extract-plugin
export var hidden = "_vv-0";